<template>
  <t-menu
    v-if="menus.length > 0"
    theme="light"
    :value="currentMenuValue"
    :collapsed="collapsed"
    :width="[232, 75]"
    @change="changeHandler"
  >
    <t-menu-item id="/" class="standalone-menu-item" value="1000_/">
      <template #icon>
        <icon-font name="icon-shouye" size="18" />
      </template>
      <span style="font-size: 14px">首页</span>
    </t-menu-item>
    <t-menu-item
      id="/complainSuggest"
      class="standalone-menu-item"
      value="1001_/complainSuggest"
    >
      <template #icon>
        <icon-font name="icon-tousu" size="18" />
        <t-badge
          v-if="$store.state.UnHandleComplainSuggest > 0"
          :count="$store.state.UnHandleComplainSuggest"
          :offset="[-160, 0]"
          size="small"
        ></t-badge>
      </template>
      <span style="font-size: 14px">投诉建议</span>
    </t-menu-item>
    <t-menu-group v-if="menus_shopping.length > 0" title="商城">
      <t-submenu v-for="item in menus_shopping" :key="item.id" :value="item.id">
        <template #icon>
          <icon-font :name="item.target" size="18" />
        </template>
        <template #title>
          <span alt="title" class="subTitle"
            >{{ item.name
            }}<t-badge dot :count="99" v-if="item.unreadNum > 0"></t-badge
          ></span>
        </template>
        <t-menu-item v-if="collapsed" class="modelTitle">{{
          item.name
        }}</t-menu-item>
        <t-menu-item
          v-for="subItem in item.children"
          :id="'/' + subItem.target.split('?')[0]"
          :key="item.id + '-' + subItem.id"
          :name="subItem.name"
          :value="item.id + '-' + subItem.id + '_/' + subItem.target"
          >{{ subItem.name
          }}<t-badge
            v-if="subItem.unreadNum > 0"
            :count="subItem.unreadNum"
            :offset="[13, -5]"
            size="small"
            class="menuBadge"
          ></t-badge
        ></t-menu-item>
      </t-submenu>
    </t-menu-group>
    <t-menu-group v-if="menus_store.length > 0" title="装修">
      <t-submenu v-for="item in menus_store" :key="item.id" :value="item.id">
        <template #icon>
          <icon-font :name="item.target" size="18" />
        </template>
        <template #title>
          <span alt="title" class="subTitle"
            >{{ item.name
            }}<t-badge dot :count="99" v-if="item.unreadNum > 0"></t-badge
          ></span>
        </template>
        <t-menu-item v-if="collapsed" class="modelTitle">{{
          item.name
        }}</t-menu-item>
        <t-menu-item
          v-for="subItem in item.children"
          :id="'/' + subItem.target"
          :key="item.id + '-' + subItem.id"
          :name="subItem.name"
          :value="item.id + '-' + subItem.id + '_/' + subItem.target"
          >{{ subItem.name
          }}<t-badge
            v-if="subItem.unreadNum > 0"
            :count="subItem.unreadNum"
            :offset="[13, -5]"
            size="small"
            class="menuBadge"
          ></t-badge
        ></t-menu-item>
      </t-submenu>
    </t-menu-group>
    <t-menu-group v-if="menus_finance.length > 0" title="财务">
      <t-submenu v-for="item in menus_finance" :key="item.id" :value="item.id">
        <template #icon>
          <icon-font :name="item.target" size="18" />
        </template>
        <template #title>
          <span alt="title" class="subTitle"
            >{{ item.name
            }}<t-badge dot :count="99" v-if="item.unreadNum > 0"></t-badge
          ></span>
        </template>
        <t-menu-item v-if="collapsed" class="modelTitle">{{
          item.name
        }}</t-menu-item>
        <t-menu-item
          v-for="subItem in item.children"
          :id="'/' + subItem.target.split('?')[0]"
          :key="item.id + '-' + subItem.id"
          :name="subItem.name"
          :value="item.id + '-' + subItem.id + '_/' + subItem.target"
          >{{ subItem.name
          }}<t-badge
            v-if="subItem.unreadNum > 0"
            :count="subItem.unreadNum"
            :offset="[13, -5]"
            size="small"
            class="menuBadge"
          ></t-badge
        ></t-menu-item>
      </t-submenu>
    </t-menu-group>
    <t-menu-group v-if="menus_settings.length > 0" title="系统">
      <t-submenu v-for="item in menus_settings" :key="item.id" :value="item.id">
        <template #icon>
          <icon-font :name="item.target" size="18" />
        </template>
        <template #title>
          <span alt="title" class="subTitle"
            >{{ item.name
            }}<t-badge dot :count="99" v-if="item.unreadNum > 0"></t-badge
          ></span>
        </template>
        <t-menu-item v-if="collapsed" class="modelTitle">{{
          item.name
        }}</t-menu-item>
        <t-menu-item
          v-for="subItem in item.children"
          v-if="subItem.target === 'system/service'"
          :id="'/im'"
          :key="item.id + '-' + subItem.id"
          :name="subItem.name"
          :value="item.id + '-' + subItem.id + '_/im'"
          >{{ subItem.name
          }}<t-badge
            v-if="subItem.unreadNum > 0"
            :count="subItem.unreadNum"
            :offset="[13, -5]"
            size="small"
            class="menuBadge"
          ></t-badge
        ></t-menu-item>
        <t-menu-item
          v-for="subItem in item.children"
          v-if="subItem.target !== 'system/service'"
          :id="'/' + subItem.target"
          :key="item.id + '-' + subItem.id"
          :name="subItem.name"
          :value="item.id + '-' + subItem.id + '_/' + subItem.target"
          >{{ subItem.name
          }}<t-badge
            v-if="subItem.unreadNum > 0"
            :count="subItem.unreadNum"
            :offset="[13, -5]"
            size="small"
            class="menuBadge"
          ></t-badge
        ></t-menu-item>
      </t-submenu>
    </t-menu-group>
  </t-menu>
</template>

<script>
export default {
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menus: [], //全部菜单
      menus_shopping: [], //分组-商城
      menus_store: [], //分组-装修
      menus_finance: [], //分组-财务
      menus_settings: [], //分组-系统
      menus_other: [], //分组-其他
      otherNames: '', //其他菜单名称
      currentMenuValue: '', //当前选中的菜单值
      menuActived: {
        group: [],
        item: 0,
      },
      websocket: null,
      wsReconnectionNum: 0,
      wsConnected: false,
      lockReconnect: false,
      mulitReConnection: null,
    }
  },
  watch: {
    '$route.path'(newValue, oldValue) {
      this.setMenuActived(newValue, oldValue)
    },
  },
  created() {
    this.getMenus()
  },
  mounted() {
    try {
      this.connectWebsocket()
    } catch (error) {
      console.warn('websocket初始化失败,将不能接收消息通知')
    }
    //调试消息通知用
    // setInterval(() => {
    //   this.testSend()//websocket消息
    //   this.browserAlert(
    //     '测试',
    //     'testtesttesttesttesttesttesttesttesttesttesttest'
    //   ) //浏览器消息
    // }, 10000)
  },
  methods: {
    testSend() {
      //测试消息
      let pust_data = {
        userRegion: 2,
        type: Math.floor(Math.random() * Math.floor(6)),
        data: Math.floor(Math.random() * Math.floor(10)),
        companyId: 5,
        message: '新消息' + Date(),
      }
      this.$axios.post('/test/notify', pust_data)
    },
    //---------------新增菜单待处理红点提示
    connectWebsocket() {
      if (this.wsConnected) return
      if (typeof WebSocket === 'undefined') {
        console.log('您的浏览器不支持WebSocket')
        return
      } else {
        let $this = this
        let protocol = 'wss'
        let url = `${this.$envConst.API_ORIGIN.replace(
          'https',
          protocol
        )}/notify/ws?Authorization=${localStorage.token}`
        // let url ='ws://127.0.0.1:8089/notify/ws?Authorization='+localStorage.token
        // console.log(url)测试
        // if (window.localtion.protocol == 'https:') {
        //   protocol = 'wss'
        // }

        // 打开一个websocket
        this.websocket = new WebSocket(url)
        var wsHeartbeat = null
        // 建立连接
        this.websocket.onopen = () => {
          $this.wsConnected = true
          console.log('websocket首次连接')
          if ($this.wsReconnectionNum > 0) {
            console.warn(`ws第${$this.wsReconnectionNum}次尝试连接成功.`)
            this.$Message.success(`与服务器的通信已恢复,消息已正常接收`)
            clearInterval($this.mulitReConnection)
            $this.mulitReConnection = null
            $this.lockReconnect = false
            $this.wsReconnectionNum = 0
          }
          wsHeartbeat = setInterval(() => {
            $this.websocket.send('pong')
            console.log('websocket心跳')
          }, 10000)
        }
        // 客户端接收服务端返回的数据
        this.websocket.onmessage = (evt) => {
          const infos = JSON.parse(evt.data)[0]
          console.log('websocket返回的数据：', infos)
          const ids = [infos.menuId || null]
          infos.menuPId && ids.unshift(infos.menuPId)
          this.setMenusDot(ids, { ...infos, data: infos.data || 1 })
        }
        // 发生错误时
        this.websocket.onerror = (evt) => {
          console.log('websocket错误：', evt)
        }
        // 关闭连接
        this.websocket.onclose = (evt) => {
          console.log(`websocket关闭,code: ${evt.code}`)
          if (evt.code === 1006 || evt.code === 1012) {
            $this.$Message.warning(
              '抱歉,因网络原因与服务器通信失败,正在尝试连接中,请耐心等候'
            )
            $this.wsConnected = false
            if (
              $this.mulitReConnection === null &&
              $this.lockReconnect === false
            ) {
              $this.reConnection()
            }
          }
          clearInterval(wsHeartbeat)
          wsHeartbeat = null
        }

        // 发生错误时
        this.websocket.onerror = (evt) => {
          console.log('websocket错误：', evt)
          //需要重连
          $this.wsConnected = false
          if ($this.wsReconnectionNum > 0) {
            this.$Message.warning(
              `尝试第${$this.wsReconnectionNum}次连接失败,请耐心等候,服务器正在恢复中`
            )
          }
        }
      }
    },
    //重连
    reConnection() {
      if (this.lockReconnect && this.wsConnected) return
      let that = this
      this.lockReconnect = true
      this.mulitReConnection = setInterval(() => {
        if (that.wsReconnectionNum < 10) {
          if (!that.wsConnected) {
            that.connectWebsocket()
            console.warn(`ws第${that.wsReconnectionNum}次重试`)
          }
          that.wsReconnectionNum++
        } else {
          console.error(`尝试恢复与服务器通信失败,请联系管理员或重新刷新页面`)
          this.$Message.error(
            `尝试恢复与服务器通信失败,请联系管理员或重新刷新页面`
          )
        }
      }, 60000)
    },
    setMenusDot(ids, { data, alert, title, message, level, type }) {
      var item = this.menus.find((value) => {
        return value.id == ids[0]
      })
      if (ids.length == 2) {
        var c_item = item.children.find((value) => {
          return value.id == ids[1]
        })
      }
      //data=1
      if (data) {
        //收到消息
        if (item && isNaN(item.unreadNum)) item.unreadNum = 0
        if (c_item) {
          if (isNaN(c_item.unreadNum)) c_item.unreadNum = 0
          item.unreadNum += data
          c_item.unreadNum += data
        } else if (item) {
          item.unreadNum += data
        }

        if (alert) {
          if (type == 90) {
            this.modal.show = true
            this.modal.title = title
            this.modal.message = message
          } else {
            const levels = ['info', 'success', 'warning', 'error']
            this.$Notice[levels[level]]({
              title,
              desc: message,
            })
            this.browserAlert(title, message)
          }
        }
        const messageAudio = document.getElementById('messageAudio')
        messageAudio.play()
      } else {
        //进入页面(已读)
        if (c_item) {
          item.unreadNum -= c_item.unreadNum
          c_item.unreadNum = 0
        } else if (item) {
          item.unreadNum = 0
        }
      }

      this.$forceUpdate()
    },
    browserAlert(title, body) {
      console.log('调用浏览器消息通知')
      const icon = 'https://img.xw-jd.com/static/logo/xwjd.png'
      if (Notification.permission === 'granted') {
        // 用户已允许通知权限，创建通知
        const notification = new Notification(title, {
          body,
          icon,
        })
        // 处理通知事件
        notification.onclick = function () {
          // 用户单击了通知
        }
      } else {
        // 用户未允许通知权限，请求通知权限
        Notification.requestPermission().then(function (permission) {
          if (permission === 'granted') {
            // 用户允许通知权限，创建通知
            const notification = new Notification(title, {
              body,
              icon,
            })
            // 处理通知事件
            notification.onclick = function () {
              // 用户单击了通知
            }
          }
        })
      }
    },
    getMenus() {
      this.menus = []
      this.menus_shopping = []
      this.menus_store = []
      this.menus_finance = []
      this.menus_settings = []
      this.menus_other = []
      this.otherNames = ''
      this.$axios.get('/user/menus').then((data) => {
        this.menus = [...this.menus, ...data]
        this.groupMenus()
        this.$store.commit('setMenus', this.menus)
        this.setMenuActived(this.$route.path)
      })
    },
    groupMenus() {
      for (const menu of this.menus) {
        if (menu.children && menu.children.length > 0) {
          menu.target = 'icon-' + menu.children[0].target.split('/')[0]
        }
      }
      for (const menu of this.menus) {
        if (!menu.children || menu.children.length === 0) continue
        const target = menu.children[0].target || ''
        if (
          target.indexOf('orders/') !== -1 ||
          target.indexOf('mall/') !== -1 ||
          target.indexOf('materials/') !== -1
        ) {
          this.menus_shopping.push(menu)
        }
      }
      for (const menu of this.menus) {
        if (!menu.children || menu.children.length === 0) continue
        const target = menu.children[0].target || ''
        if (
          target.indexOf('roadwork/') !== -1 ||
          target.indexOf('franchisee/') !== -1 ||
          target.indexOf('budget/') !== -1
        ) {
          if (menu.name === '装修管理') menu.target = 'icon-zxmg'
          this.menus_store.push(menu)
        }
      }
      for (const menu of this.menus) {
        if (!menu.children || menu.children.length === 0) continue
        const target = menu.children[0].target || ''
        if (
          target.indexOf('bill/') !== -1 ||
          target.indexOf('finance/') !== -1
        ) {
          this.menus_finance.push(menu)
        }
      }
      for (const menu of this.menus) {
        if (!menu.children || menu.children.length === 0) continue
        const target = menu.children[0].target || ''
        if (
          target.indexOf('system/') !== -1 ||
          target.indexOf('dataAnalysis/') !== -1 ||
          target.indexOf('settlement/') !== -1 ||
          target.indexOf('setting/') !== -1 ||
          target.indexOf('systemLogs/') !== -1
        ) {
          if (menu.name === '企业入驻管理') menu.target = 'icon-guanlianqiye'
          this.menus_settings.push(menu)
        }
      }
      for (const menu of this.menus) {
        if (!menu.children || menu.children.length === 0) continue
        const child = menu.children[0]
        if (
          (child.target || '').indexOf('complainSuggest') !== -1 ||
          child.name === '企业概览'
        ) {
          this.menus_other.push(child)
          this.otherNames += child.name
        }
      }
    },
    setMenuActived(newValue, oldValue) {
      const standaloneMenuValues = {
        '/': '1000_/',
        '/complainSuggest': '1001_/complainSuggest',
      }
      if (standaloneMenuValues[newValue]) {
        this.menuActived.group = []
        this.menuActived.item = standaloneMenuValues[newValue].split('_')[0]
        this.currentMenuValue = standaloneMenuValues[newValue]
        return
      }
      if (newValue !== oldValue) {
        for (let i = 0; i < this.menus.length; i++) {
          const currentMenu = this.menus[i].children.find(
            (subItem) => newValue === `/${subItem.target}`
          )
          if (currentMenu) {
            this.menuActived.group = [currentMenu.parentId]
            this.menuActived.item = currentMenu.parentId + '-' + currentMenu.id
            this.currentMenuValue =
              currentMenu.parentId +
              '-' +
              currentMenu.id +
              '_/' +
              currentMenu.target
            return
          }
        }
      }
    },
    changeHandler(active) {
      if (active != null && active.indexOf('_') != -1) {
        this.currentMenuValue = active
        const value = active.split('_')
        this.$router.push(value[1], () => {})
        if (value[0].indexOf('-') != -1) {
          this.setMenusDot(String(value[0]).split('-'), {})
        }
      }
    },
  },
}
</script>
<style lang="stylus" scoped>
>>>.t-default-menu.t-is-collapsed .t-menu-group__title
    display: none !important
>>>.t-menu__content
    font-size: 14px
>>>.t-menu__item
    height: 48px !important
    font-weight: 400
    margin: 0 !important
>>>.standalone-menu-item.t-is-active
    color #1456F0 !important
    background #EEF4FF !important
    font-weight 500
.t-is-active
  color #1456F0 !important
  .subTitle
    color #1456F0 !important
.t-is-opened
  .subTitle
    color rgba(0, 0, 0, 0.9) !important
>>>.subTitle
    padding-left 10px
    font-size 14px !important
>>>.menuBadge
  position absolute
  top 29px
  right 5px
>>>.t-badge--dot
    left 8px
    width 8px
    height 8px
    top -6.5px
>>>.menuBadge
    width 30px
>>>.t-menu__operations
    &:hover
      border-radius 4px
      background #F3F3F3
.t-menu__popup-wrapper
  >li
    width: 226px
    height: 48px
    font-weight: 500
    color:rgba(0, 0, 0, 0.9)
  >li:first-child
    font-size: 15px !important
    border-bottom: 1px solid #E7E7E7
    pointer-events: none;
    color:#8D8D8D
>>>.t-menu__content
    margin-left: 8px
</style>
